import { FieldProps, FormikProps, FormikValues } from 'formik';
import React from 'react';
import { InfoImage, SelectedItem as SelectedItemCircle } from 'src/assets/images';
import { Tooltip } from 'src/components';
import {
  LinkName,
  PaymentRequestTealiumService,
  UIInteractionType,
} from 'src/containers/self-service/generate-payment-request/tagging/payment-request-tealium-service';

interface Props extends FieldProps {
  tooltip: string;
  icon: string;
  label: string;
  resetFields: string[];
}

function resetFormValues(form: FormikProps<FormikValues>, fields: string[]) {
  for (const field of fields) {
    form.setFieldValue(field, '');
  }
}

export function RequestCategoryItem(props: Props) {
  const isSelected = props.form.values[props.field.name] === props.field.value;
  const tooltipParent = React.useRef<HTMLDivElement>(null);

  return (
    <section
      className="z-0"
      onClick={() => {
        props.form.setFieldValue(props.field.name, props.field.value);

        if (props?.resetFields?.length) {
          resetFormValues(props.form, props.resetFields);
        }

        PaymentRequestTealiumService.onUIInteraction(
          LinkName.GENERATE_PAYMENT_REQUEST,
          UIInteractionType[props.field.value],
        );
      }}
    >
      <div
        ref={tooltipParent}
        className="relative [&_.tippy-child-container]:z-10 [&_.tippy-child-container]:absolute [&_.tippy-child-container]:top-[14px] [&_.tippy-child-container]:left-[14px] w-38 md:w-46"
      >
        <div
          className={`w-38 md:w-46 flex-none flex-grow-0 static h-50 cursor-pointer text-center rounded-10 flex pt-8 flex-col items-center ${
            isSelected ? 'bg-grey-600 shadow-active' : 'bg-grey-800'
          }`}
        >
          <div className={`w-20 h-20`}>
            <img className="w-14 h-14" src={props.icon} />
          </div>
          <p className="capitalize block-text">{props.label}</p>
        </div>
        <div className="bg-grey-500 rounded-full absolute w-[30px] h-[30px] top-[10px] right-[10px] cursor-pointer">
          {isSelected ? <img src={SelectedItemCircle} /> : ''}
        </div>

        <Tooltip
          showOnHover
          isMobile={false}
          onOpenEvent={() => {
            PaymentRequestTealiumService.onUIInteraction(
              LinkName.GENERATE_PAYMENT_REQUEST,
              `${UIInteractionType[props.field.value] as UIInteractionType} ${
                UIInteractionType.Help
              }`,
            );
          }}
          lightMode
          content={props.tooltip}
        >
          <img className="w-5 h-5 cursor-pointer" src={InfoImage} />
        </Tooltip>
      </div>
    </section>
  );
}
